import React, {Component} from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import './_table.scss';
import MagicoPaginationComponent from "./MagicoPaginationComponent";

export default class NTMTable extends Component {

	render() {

		let {header, body, defaultPageSize, filterable, title, showPagination=true} = this.props;

		let columns = title ? [{Header: title, columns: header}] : header;
		return (
			<ReactTable
				data={body || []}
				columns={columns}
				defaultPageSize={defaultPageSize || 5}
				defaultFilterMethod={(filter, row) =>
					!!row[filter.id] && row[filter.id].toString().toLowerCase().includes(filter.value.toLowerCase())}
				filterable={filterable}
				previousText={"Precedente"}
				nextText={"Successiva"}
				noDataText={"Non ci sono dati"}
				pageText={"Pagina"}
				ofText={"di"}
				rowsText={"ELEMENTI"}
				className={"-highlight"}
				PaginationComponent={MagicoPaginationComponent}
				showPagination={showPagination}
			/>
		);
	}
}
